/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import PropTypes from "prop-types";

// @mui material components
import Modal from "@mui/material/Modal";
import Divider from "@mui/material/Divider";
import Slide from "@mui/material/Slide";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function MDModal({ open, onClose, title, children, size = "md", ...other }) {
  const getModalWidth = () => {
    switch (size) {
      case "sm":
        return "400px";
      case "lg":
        return "800px";
      case "xl":
        return "1200px";
      default:
        return "600px";
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      {...other}
    >
      <Slide direction="down" in={open} mountOnEnter unmountOnExit>
        <MDBox
          sx={{
            width: getModalWidth(),
            maxWidth: "90vw",
            maxHeight: "90vh",
            bgcolor: "background.paper",
            borderRadius: "lg",
            boxShadow: 24,
            outline: "none",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Modal Header */}
          <MDBox
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: 3,
              borderBottom: "1px solid",
              borderColor: "divider",
            }}
          >
            <MDTypography variant="h5" component="h2">
              {title}
            </MDTypography>
            <IconButton onClick={onClose} size="small">
              <Icon>close</Icon>
            </IconButton>
          </MDBox>

          {/* Modal Content */}
          <MDBox
            sx={{
              flex: 1,
              overflow: "auto",
              p: 0,
            }}
          >
            {children}
          </MDBox>
        </MDBox>
      </Slide>
    </Modal>
  );
}

// Typechecking props for the MDModal
MDModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
  size: PropTypes.oneOf(["sm", "md", "lg", "xl"]),
};

export default MDModal; 